<form [formGroup]="edtfFormGroup" class="sh-clear-margin-bottom">
    <sh-form-group [invalid]="!!formControl.errors">
        <div class="sh-form-row-with-action" style="margin-bottom: 0">
            <div class="sh-form-row-with-action__inputs">
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-label [label]="typeLabel" [for]="typeControlId" [required]="required"></sh-form-label>
                    <sh-form-select-base
                        [formControl]="typeControl"
                        [id]="typeControlId"
                        [options]="edtfTypeOptions$ | async"
                        [placeholderMsg]="typePlaceholderMsg$ | async"
                    ></sh-form-select-base>
                </div>
                <div class="sh-form-group sh-form-row-with-action__inputs__item" [class.-sh-is-invalid]="invalid">
                    <sh-form-label [label]="valueLabel" [for]="valueControlId" [required]="required"></sh-form-label>
                    <input
                        type="text"
                        autocomplete="off"
                        [formControl]="valueControl"
                        [id]="valueControlId"
                        [attr.placeholder]="(valuePlaceholder$ | async) || null"
                        class="sh-form-group__input sh-input-field"
                        [attr.disabled]="disabled || valueDisabled ? true : null"
                    />
                </div>
            </div>
        </div>
        <div *ngIf="combinedErrorMessage$ | async as combinedErrorMessage" class="sh-form-group sh-clear-margin-bottom -sh-is-invalid">
            <p class="sh-form-group__feedback">{{ combinedErrorMessage }}</p>
        </div>
    </sh-form-group>
</form>
